module.exports = __webpack_public_path__ + "static/media/5v.6d39b49b.jpg";